<template>
  <el-dialog
    :visible.sync="open"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="true"
    :style="{'background-color': BGColor,'backdrop-filter': `blur(${BGBlur}px)`}"
  >
    <div
      :class="`FS${size}`"
      :style="{'color':color}"
      class="align-center"
      style="transform: translateY(-10vh)"
    >
      <div v-if="type === 'planet'">
        <div class="planet">
          <img class="ball" :src="ball" alt="">
          <img class="ring" :src="ring" alt="">
        </div>
        <p>{{ text }}</p>
      </div>

      <div v-else class="default" :style="{'background-color': defaultBGColor,'--bgc': defaultBGColor}">
        <i class="el-icon-loading" :class="`FS${size+6}`"/>
        <p>{{ text }}</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {ball} from "./ball-base64"
import {ring} from "./ring-base64";

export default {
  name: "hFullLoad",
  props: {
    loading: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: "#ffffff"
    },
    text: {
      type: String,
      default: "拼命加载中..."
    },
    type: {
      type: String
    },
    BGColor: {
      type: String
    },
    defaultBGColor: {
      type: String,
      default: "#4a4a4a"
    },
    BGBlur: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      ball: ball,
      ring: ring,
      open: false
    }
  },
  created() {
    document.getElementsByTagName("body")[0].style.setProperty("--color", this.color)
  },
  watch: {
    loading: {
      handler(newVal) {
        this.open = newVal;
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  background-color: transparent;
  box-shadow: none;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__close {
  color: var(--color);
}

.planet {
  width: 500px;
  height: 500px;
  position: relative;

  img {
    top: 125px;
    left: 125px;
    position: absolute;
  }

  .ball {
    width: 250px;
    height: 250px;
    border-radius: 50%;
    animation: ball 10s linear infinite;
  }

  @keyframes ball {
    0% {
      transform: rotate(0deg);
      box-shadow: 0 0 500px 0 rgba(255, 255, 255, 0.8);
    }
    50% {
      transform: rotate(180deg);
      box-shadow: 0 0 500px 0 rgba(255, 255, 255, 0.3);
    }
    100% {
      transform: rotate(360deg);
      box-shadow: 0 0 500px 0 rgba(255, 255, 255, 0.8);
    }
  }

  .ring {
    width: 450px;
    height: 450px;
    animation: ring 10s linear infinite;
  }

  @keyframes ring {
    0% {
      opacity: 1;
      transform: scale(1) translate(-22.15%, -22%);
    }
    50% {
      opacity: 0.4;
      transform: scale(1.01) translate(-22.15%, -22%);
    }
    100% {
      opacity: 1;
      transform: scale(1) translate(-22.15%, -22%);
    }
  }
}

.default {
  padding: 30px 50px;
  border-radius: 5px;
  box-shadow: 0 2px 6px var(--bgc);
}
</style>
